import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { Veiculo } from '../../types/logistica';
import { veiculosService } from '../../services';

const columns: ResourceColumn<Veiculo>[] = [
  { header: "Placa", accessor: "placa" },
  { header: "Tipo", accessor: "tipo" },
  { header: "Marca", accessor: "marca" },
  { header: "Modelo", accessor: "modelo" },
  { header: "Ano", accessor: "ano_fabricacao" },
  { header: "Capacidade (kg)", accessor: "capacidade_kg" },
  { header: "Status", accessor: "status" },
];

export const VeiculosListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Veículos"
      description="Gerenciamento de veículos da frota."
      columns={columns}
      service={veiculosService}
      createPath="/admin/logistica/veiculos/novo"
      onEdit={(item) => item.id && navigate(`/admin/logistica/veiculos/${item.id}`)}
    />
  );
};
